function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState } from "react";
import hyper from "@macrostrat/hyper";
import { Tag, Card, Button, Collapse, Switch } from "@blueprintjs/core";
import { useFilterState, useAppActions } from "~/map-interface/app-state";
import { useAdmoinshments } from "./admonishments";
import styles from "./filters.module.styl";
var h = hyper.styled(styles);

function Filter(_ref) {
  var filter = _ref.filter;
  var runAction = useAppActions();

  var remove = function remove() {
    return runAction({
      type: "remove-filter",
      filter: filter
    });
  };

  var swapFilterType = function swapFilterType() {
    // Copy the filter, otherwise all hell breaks loose
    var newFilter = JSON.parse(JSON.stringify(filter)); // Swap the style of filter

    if (newFilter.type.substr(0, 4) === "all_") {
      newFilter.type = newFilter.type.replace("all_", "");
    } else {
      newFilter.type = "all_".concat(newFilter.type);
    }

    runAction({
      type: "async-add-filter",
      filter: newFilter
    });
  };

  var name = filter.name,
      category = filter.category,
      type = filter.type;
  var isTypeAll = type.substr(0, 4) === "all_";
  var label = isTypeAll ? "All matches" : "Best matches";
  return h("div.filter-tag", [h(Tag, {
    onRemove: remove,
    interactive: true,
    style: {
      backgroundColor: "#D9822B"
    }
  }, [name]), h["if"](category == "lithology")(Switch, {
    style: {
      margin: 0
    },
    alignIndicator: "right",
    label: label,
    checked: isTypeAll,
    onChange: swapFilterType
  })]);
}

function Filters() {
  var _useFilterState = useFilterState(),
      filters = _useFilterState.filters;

  var shouldFiltersBeOpen = filters.length > 0;
  return h("div.filter-container", [h["if"](!shouldFiltersBeOpen)("div", ["No Filters. To add filters begin searching.."]), h["if"](shouldFiltersBeOpen)(filters.map(function (filter, key) {
    return h(Filter, {
      key: key,
      filter: filter
    });
  }))]);
}

function makeFilterString(filters) {
  var timeFilters = filters.filter(function (f) {
    return f.category === "interval";
  }).map(function (f) {
    return f.name;
  });
  var otherFilters = filters.filter(function (f) {
    return f.category !== "interval";
  }).map(function (f) {
    return f.name;
  });
  var otherFiltersString = otherFilters.join(" OR ");
  var timeFiltersString = timeFilters.join(" OR ");

  if (otherFilters.length > 1 && timeFilters.length > 0) {
    otherFiltersString = "(" + otherFiltersString + ")";
  }

  if (timeFilters.length > 1 && otherFilters.length > 0) {
    timeFiltersString = "(" + timeFiltersString + ")";
  }

  var finalString = [timeFiltersString, otherFiltersString].filter(function (s) {
    return s.length > 0;
  }).join(" AND ");
  return finalString;
}

function FilterPanel() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useFilterState2 = useFilterState(),
      filters = _useFilterState2.filters;

  var runAction = useAppActions();
  var admonishments = useAdmoinshments();

  if (filters.length == 0 && admonishments.length == 0) {
    return null;
  }

  var filterString = makeFilterString(filters);

  var onClick = function onClick() {
    setOpen(!open);
  };

  var onRemoveAll = function onRemoveAll() {
    runAction({
      type: "clear-filters"
    });
  };

  var iconName = open ? "chevron-up" : "chevron-down";
  return h(Card, {
    className: "filter-tongue"
  }, [h(Admonishments, {
    admonishments: admonishments
  }), h["if"](filters.length > 0)("div.filters", [h("div.filter-name-container", [h("p.filter-names", [h("b", "Filtering by: "), filterString]), h("div.filter-tongue-actions", [h("div.remove", {
    onClick: onRemoveAll
  }, ["remove all"]), h(Button, {
    minimal: true,
    small: true,
    icon: iconName,
    onClick: onClick
  })])]), h(Collapse, {
    isOpen: open
  }, [h(Filters)])])]);
}

function Admonishments(_ref2) {
  var admonishments = _ref2.admonishments;

  if (admonishments.length == 0) {
    return null;
  }

  return h("div.admonishments", admonishments);
}

export default Filters;
export { FilterPanel };